import React from 'react'
import {observable, action, runInAction} from 'mobx'
import reportManagementAPI from '../apis/reportManagementAPI'
import alertMessage from '../utils/alertMessage'
import {t} from 'i18next'
import {Menu, Tooltip} from 'antd'

export default class reportManagementStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable customerValue = null
  @observable reportRoleList = []
  @observable reportConditionOperatorList = []
  @observable reportSqlList = []
  @observable reportMenuRenderNumber = 0
  @observable reportMenus = []
  @observable reportPageCondition = []
  @observable tabsInfo = {}
  @observable reportTableData = {
    tableData: [],
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
  }
  @observable reportSortChange = Math.random()

  @action
  async getReportRoles() {
    try {
      const response = await reportManagementAPI.getReportRoles()
      const {data, code} = response.data

      runInAction(() => {
        if (code === 0) {
          this.reportRoleList = data
        } else {
        }
      })
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async getReportList(params) {
    this.isFetching = true
    try {
      const response = await reportManagementAPI.getReportList(params)
      const {code, message} = response.data

      runInAction(() => {
        this.isFetching = false
        if (code === 0) {
        } else {
          alertMessage.error(message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async setReportStatus(id, status, type) {
    try {
      const response = await reportManagementAPI.setReportStatus(id, status, type)
      const {code, message} = response.data
      const tipsText = status ? t(`general.unlock`) : t(`general.lock`)

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`${tipsText} Success！`)
          this.reportMenuRenderNumber = Math.random()
        } else {
          alertMessage.error(`${tipsText} Failed！` + message)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async deleteReport(id) {
    try {
      const response = await reportManagementAPI.deleteReport(id)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Delete Success！`)
          this.reportMenuRenderNumber = Math.random()
        } else {
          alertMessage.error(`Delete Failed！` + message)
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async getReportConditions() {
    try {
      const response = await reportManagementAPI.getReportConditions()
      const {data, code} = response.data

      runInAction(() => {
        if (code === 0) {
          this.reportConditionOperatorList = data
        } else {
        }
      })
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async analysisReportSql(params) {
    try {
      const response = await reportManagementAPI.analysisReportSql(params)
      const {data, code} = response.data
      const {metaData} = data
      runInAction(() => {
        if (code === 0) {
          this.reportSqlList = metaData
        } else {
        }
      })
      return response.data
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async saveReport(params) {
    try {
      const response = await reportManagementAPI.saveReport(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Save Success！`)
          this.reportMenuRenderNumber = Math.random()
        } else {
          alertMessage.error(`Save Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async saveReportSearchData(params) {
    try {
      const response = await reportManagementAPI.saveReportSearchData(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Save Success！`)
          this.reportMenuRenderNumber = Math.random()
        } else {
          alertMessage.error(`Save Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async getReportSearchData(params) {
    try {
      const response = await reportManagementAPI.getReportSearchData(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
        } else {
          alertMessage.error(message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async getReportDetail(id) {
    try {
      const response = await reportManagementAPI.getReportDetail(id)
      const {data, code, message} = response.data
      runInAction(() => {
        if (code === 0) {
          this.reportPageCondition = data.conditions
          this.tabsInfo = {name: data.reportName, id: data.id, type: data.type, pbiUrl: data?.pbiUrl}
        } else {
          alertMessage.error(`Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async setReportPageCondition(conditionNull) {

    this.reportPageCondition = conditionNull

  }


  @action
  async getReportMenu(image1, image2, url1, url2) {
    try {
      const response = await reportManagementAPI.getReportMenu()
      const {code, data} = response.data
      let finaleMenu
      runInAction(() => {
        if (code === 0) {
          this.reportMenus = data

          finaleMenu = data.map(({id, name, type}) => {
            return {
              label: (
                <Tooltip placement="right" color="#01244f" title={name}>
                  <div style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>
                    {/*<img src={type === '查询语句' ? image1 : image2} alt=""/>*/}
                    {name}
                  </div>
                </Tooltip>
              ),
              key: id,
              type,
              onClick: type === '查询语句' ? url1 : url2,
            }
          })
        } else {
        }
      })
      return {code, finaleMenu}
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async getReportPage(params) {
    this.isFetching = true
    try {
      const response = await reportManagementAPI.getReportPage(params)
      const {code, message} = response.data

      runInAction(() => {
        this.isFetching = false
        if (code === 0) {
        } else {
          alertMessage.error(message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async getInSearchList(params) {
    try {
      const response = await reportManagementAPI.getInSearchList(params)
      const {code} = response.data

      runInAction(() => {
        if (code === 0) {
        } else {
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async getExportPageList(params) {
    try {
      const response = await reportManagementAPI.getExportPageList(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
        } else {
          alertMessage.error(message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async generateReport(params) {
    try {
      const response = await reportManagementAPI.generateReport(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
        } else {
          alertMessage.error(message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async deleteGenerateReport(id) {
    try {
      const response = await reportManagementAPI.deleteGenerateReport(id)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Delete Success！`)
        } else {
          alertMessage.error(`Delete Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async deleteReportSearchData(id) {
    try {
      const response = await reportManagementAPI.deleteReportSearchData(id)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Delete Success！`)
        } else {
          alertMessage.error(`Delete Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async updateUseReportSearchData(id) {
    try {
      const response = await reportManagementAPI.updateUseReportSearchData(id)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Use Success！`)
        } else {
          alertMessage.error(`Use Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async cancelGenerateReport(id) {
    try {
      const response = await reportManagementAPI.cancelGenerateReport(id)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Cancel Success！`)
        } else {
          alertMessage.error(`Cancel Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async getReportConfig(reportId) {
    try {
      const response = await reportManagementAPI.getReportConfig(reportId)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
        } else {
          alertMessage.error(message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async saveReportConfig(params) {
    try {
      const response = await reportManagementAPI.saveReportConfig(params)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          alertMessage.success(`Save Success！`)
        } else {
          alertMessage.error(`Save Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeTableData(data) {
    this.reportTableData = data
  }

  @action
  async saveReportSort(id, sort) {
    try {
      const response = await reportManagementAPI.saveReportSort(id, sort)
      const {code, message} = response.data

      runInAction(() => {
        if (code === 0) {
          // alertMessage.success(`Save Success！`)
        } else {
          alertMessage.error(`Save Failed！` + message)
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onSortChange() {
    this.reportSortChange = Math.random()
  }
}
